import { useEffect, useState } from 'react';
import store from '../../store';
import BillingPeriodSet from '../../entities/BillingPeriodSet';

const getStartIndexFromStore = (startDate: string, billingPeriodSet: BillingPeriodSet): number => {
  return billingPeriodSet.getBillingPeriods().findIndex((period) => {
    const startDateUTC = new Date(startDate);
    const periodStartUTC = new Date(
      Date.UTC(
        period.getStart().getFullYear(),
        period.getStart().getMonth(),
        period.getStart().getDate()
      )
    );
    return periodStartUTC.getTime() === startDateUTC.getTime();
  });
};

const useBillingPeriod = () => {
  const [billingPeriodSet] = useState(new BillingPeriodSet(new Date()));
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const currentStartDate = store.getState().onboardingInfo.billingPeriod.startDate as string;
    const startIndex = !!currentStartDate
      ? getStartIndexFromStore(currentStartDate, billingPeriodSet)
      : 0;
    setSelectedIndex(startIndex);
  }, [billingPeriodSet]);

  return {
    billingPeriodSet,
    selectedIndex,
    setSelectedIndex
  };
};

export default useBillingPeriod;
